<template>
  <div class="auth-page">
    <div class="user-not-registred__wrapper">
      <div class="auth-block user-not-registred__grid">
        <div class="auth-block__logo">
          <img
            class="auth-block__logo__image"
            :src="require(`@/assets/images/logo_${$config.styleName}.svg`)"
            alt="logo"
            width="121"
            height="93"
          >
          <span class="auth-block__logo__title">{{ $t('common.portal') }}</span>
        </div>
        <div class="header__name user-not-registred__url">
          {{ $t('views.user_not_registred.not_registred') }}<br>
          {{ $t('views.user_not_registred.contact_administrator') }}
        </div>
        <div class="user-not-registred__link">
          <router-link
            class="user-not-registred__text"
            :to="{name: 'SignIn'}"
            tag="span"
          >
            {{ $t('views.not_found.reroute_signin') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UserNotRegistred',
};
</script>

<style lang="scss" scoped>
.user-not-registred {
  justify-content: center;

  &__link {
    align-items: flex-start;
    text-align: center;
  }

  &__text {
    color: var(--margaritas);
    cursor: pointer;
    border-bottom: 1px solid var(--margaritas);
    transition: 0.3s ease-in-out;
    transition-property: color, border-bottom-color;
    text-align: center;

    &:hover {
      color: var(--aurum);
      border-bottom-color: var(--aurum);
    }
  }

  &__grid {
    grid-template-rows: min-content auto 100px;
    justify-content: center;
  }

  &__url {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
</style>
